import {Tls} from '../tools/Tls';
import {DrawTls} from '../tools/DrawTls';
import { TransTls } from '../tools/TransTls';


const TransDrawer = {
    draw(mymap, transRow) {

        var cn = Tls.str2centerInUTM(transRow.points);
        var phase = 3;

        try {
           let main = DrawTls.drawRectangle(mymap, cn[0], cn[1], phase, phase, Tls.rectStr2angle(transRow.points));
            // this.drawPoleSkin(mymap, pjjj, w);
             let skin = DrawTls.drawCircle(mymap, cn[0], cn[1], phase)

            //  main.myId = transRow._id;
            //  main.myType = 'pole';
            //  skin.myId = transRow._id;
            //  skin.myType = 'pole';

             skin.bindPopup(TransTls.getInfo(transRow));

             return {main,skin};
             
        } catch (e) {
            console.log(e);
        }
        return {};

    }
};

export {TransDrawer}